import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Utils from "../../core/Utils";
import { Stack } from "@mui/system";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import styled from "@emotion/styled";
import TablePagination from "@mui/material/TablePagination";
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const SelectCustomerComponent = ({
  open,
  close,
  fetchedCustomerPasses,
  setSelectedCustomerPass,
  selectedCustomerPass,
  showSelectCustomerPopup,
  showVehicleSelect,
  isTwoWheeler,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    setPage(0);
    setRowsPerPage(10);
  }, [fetchedCustomerPasses]);

  const listRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    listRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedCustomerPasses =
    fetchedCustomerPasses?.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    ) || [];

  const AddCustomerDetails = (selectedCustomerPass) => {
    if (!Utils.IsNullOrEmptyObject(selectedCustomerPass)) {
      showVehicleSelect(selectedCustomerPass);
    } else {
      showSelectCustomerPopup();
    }
  };
  return (
    <BootstrapDialog
      onClose={close}
      aria-labelledby="customized-dialog-title"
      className="cs-modal-sec"
      open={open}
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={close}>
        <Typography
          level="h3"
          component="h3"
          fontWeight="600"
          fontSize="2rem"
          className="h3"
        >
          Select Customer
        </Typography>
      </BootstrapDialogTitle>
      <DialogContent
        dividers
        className="modal-dialog-content"
        sx={{ backgroundColor: "#f4f4f4" }}
      >
        <Stack spacing={2} ref={listRef}>
          {!Utils.IsNullOrEmptyArray(fetchedCustomerPasses) &&
            paginatedCustomerPasses.map((customerPass) => {
              return (
                <Grid
                  container
                  sx={{
                    padding: "15px",
                    cursor: "pointer",
                    border:
                      selectedCustomerPass?.id === customerPass?.id
                        ? "2px solid #1976d2"
                        : "2px solid transparent",
                    backgroundColor:
                      selectedCustomerPass?.id === customerPass?.id
                        ? "#e3f2fd"
                        : "#fff",
                    transition: "all 0.2s ease",
                  }}
                  className="card white-bg"
                  onClick={() => {setSelectedCustomerPass(customerPass); AddCustomerDetails(customerPass)}}
                >
                  <Stack direction="row" spacing={2}>
                    <Grid container style={{ "align-items": "center" }}>
                      <Grid
                        xs={12}
                        md={4}
                        style={{
                          "flex-basis": "auto",
                          "padding-right": "20px",
                        }}
                      >
                        <Avatar
                          sx={{ width: "84px", height: "84px" }}
                          alt="S"
                        />
                      </Grid>
                      <Grid xs={12} md={8}>
                        <Typography
                          level="h3"
                          component="h3"
                          fontWeight="600"
                          fontSize="2rem"
                          className="h3"
                        >
                          {customerPass?.userName || ""}
                        </Typography>
                        <Stack direction="row" spacing={2} marginTop="10px">
                          <Stack
                            direction="row"
                            className="card"
                            sx={{
                              padding: "6px 15px",
                              display: "flex",
                              width: "fit-content",
                            }}
                          >
                            <PhoneOutlinedIcon sx={{ alignSelf: "center" }} />{" "}
                            &nbsp;{" "}
                            <span>{customerPass?.mobileNumber || ""}</span>
                          </Stack>
                        </Stack>
                        <Stack
                          direction="row"
                          className="card"
                          sx={{
                            padding: "6px 15px",
                            display: "flex",
                            mt: 2,
                            width: "fit-content",
                          }}
                        >
                          <MailOutlinedIcon sx={{ alignSelf: "center" }} />{" "}
                          &nbsp; <span>{customerPass?.emailId || ""}</span>
                        </Stack>
                      </Grid>
                      {!Utils.IsNullOrEmpty(customerPass?.vehicleDetails) &&
                        customerPass?.vehicleDetails.some(
                          (x) => !Utils.IsNullOrEmpty(x?.number),
                        ) && (
                          <Grid mt={2}>
                            <Typography
                              level="h4"
                              component="h4"
                              fontWeight="600"
                              fontSize="1rem"
                              className="h4"
                            >
                              Vehicle Numbers
                            </Typography>
                            <Grid
                              container
                              spacing={2}
                              mt={2}
                              gap={2}
                              ml={1}
                              sx={{ display: "flex", flexWrap: "wrap" }}
                            >
                              {customerPass?.vehicleDetails.map((vehicle) => {
                                return (
                                  vehicle?.number && (
                                    <Stack
                                      className="card"
                                      sx={{
                                        padding: "6px 15px",
                                        display: "flex",
                                        width: "fit-content",
                                      }}
                                    >
                                      <Stack direction="row" spacing={2}>
                                     {isTwoWheeler ? <TwoWheelerIcon sx={{ alignSelf: "center" }} /> : <DirectionsCarIcon sx={{ alignSelf: "center" }} /> }
                                     <span>{vehicle?.number || ""}</span>
                                      </Stack>
                                      <Stack direction="row" spacing={1}>
                                        <Typography>Make :</Typography>
                                        <Typography>{vehicle?.make || ""}</Typography>
                                      </Stack>
                                      <Stack direction="row" spacing={1}>
                                        <Typography>Model :</Typography>
                                        <Typography>{vehicle?.model || ""}</Typography>
                                      </Stack>
                                    </Stack>
                                  )
                                );
                              })}
                            </Grid>
                          </Grid>
                        )}
                    </Grid>
                  </Stack>
                </Grid>
              );
            })}
        </Stack>
        {fetchedCustomerPasses?.length > 10 && <TablePagination
          component="div"
          count={fetchedCustomerPasses?.length || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />}
      </DialogContent>
      <DialogActions
        style={{ padding: "15px", display: "flex", justifyContent: "flex-end" }}
      >
        <FormControl>
          <Button
            type="submit"
            variant="contained"
            className="btn btn-secondary"
            onClick={close}
          >
            Cancel
          </Button>
        </FormControl>
        {/* <FormControl>
          <Button
            type="submit"
            variant="contained"
            className="btn btn-primary"
            onClick={AddCustomerDetails}
          >
            Add
          </Button>
        </FormControl> */}
      </DialogActions>
    </BootstrapDialog>
  );
};

export default SelectCustomerComponent;
